import { ProviderViewCallParticipant } from '../useProviderViewCallParticipants';
import { getTestCallParticipantVideo } from './getTestCallParticipantVideo';
import { testPatientData } from './testPatientData';
import { getTestWaitingMember } from './getTestWaitingMember';
export type TestCallParticipant = ProviderViewCallParticipant & {
  videoElement: HTMLVideoElement;
};
export const getTestCallParticipant = (): TestCallParticipant => {
  return {
    ...getTestWaitingMember(),
    username: testPatientData.username,
    hasVideo: true,
    hasAudio: true,
    videoElement: getTestCallParticipantVideo(testPatientData.videoUrl),
    videoDisabledReason: null,
    videoDisableWarning: false,
    hasScreenAudio: false,
  };
};
